import { render, staticRenderFns } from "./AdminWorkspacesFromClients.vue?vue&type=template&id=d164ddb6&scoped=true"
import script from "./AdminWorkspacesFromClients.vue?vue&type=script&lang=ts"
export * from "./AdminWorkspacesFromClients.vue?vue&type=script&lang=ts"
import style0 from "./AdminWorkspacesFromClients.vue?vue&type=style&index=0&id=d164ddb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d164ddb6",
  null
  
)

export default component.exports